import { api } from '~/services/api'

export const getCancellations = async (params) => {
  return api.get('/v4/cancellations', params ? { params } : {})
}
